import { styled } from "@mui/material/styles";

const ContentContainer = styled("div")(() => ({
  position: "relative",
  transition: "transform 300ms ease-in-out",
}));

export default ContentContainer;
